import React from "react"
import Accordion from "../../components/Accordion"
import { ButtonLoader } from "../../components/Button"
import { ButtonClose } from "../../components/ChatCloseButton"
import { getInputTypeIndicators } from "../../components/GetInputType/farmerProfile"
import { IndicatorBadge } from "../../components/Badge"
import { CheckBox } from "../../components/Form"
import "./styles.scss"

const actions = [
  { type: "edit", description: "Editar" },
  { type: "copy", description: "Copiar Campo" },
]

const StepFormFields = ({
  formQuestions,
  editIndex,
  editedChatFields,
  onChangeQuestionsInfo,
  values,
  loadingField,
  handleSave,
  handleEdit,
  handleCancel,
  stepId,
  handleCopy,
  hasCheckBox,
  allFields,
}) => {
  const renderButtons = (action, index, stepIndex, answer, field, formId) => {
    const iconStyles = { color: "#99AA99" }

    const iconTypeMap = {
      edit: "pencil",
      copy: "copy",
    }

    const actionHandlers = {
      copy: (e) => handleCopy(e, answer),
      edit: () => handleEdit(field, stepIndex, formId),
      talk: () => {},
    }

    const typeIcon = iconTypeMap[action.type]
    const handler = answer === "" ? actionHandlers.add : actionHandlers[action.type]
    const icon = answer === "" ? iconTypeMap.add : typeIcon

    return (
      <div key={index} className="steps__item-field-actions-buttons" onClick={handler}>
        <i title={action.description} className={`fi fi-rr-${icon}`} style={iconStyles}></i>
      </div>
    )
  }

  return (
    Array.isArray(formQuestions) &&
    formQuestions.map((formQuestion, indexField) => (
      <div key={indexField} className="steps__item">
        <div className="steps__item-field">
          <div className={`steps__item-field-details`}>
            <span className="details-name">
              {formQuestion.question.title} (Formulário: {formQuestion.form})
            </span>
            <div className="details-answer">
              {editIndex === formQuestion.id ? (
                <div className="details-answer__edit-field" style={formQuestion.question.type === "radio" ? { alignItems: "end", justifyContent: "space-between" } : {}}>
                  {getInputTypeIndicators(
                    formQuestion.id,
                    formQuestion.question,
                    formQuestion.formId,
                    onChangeQuestionsInfo,
                    values,
                  )}
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <ButtonLoader
                      loading={loadingField}
                      className="loader-indicators"
                      messageProcess="Salvando"
                      label="Confirmar"
                      variant="outline"
                      handleClick={() => handleSave(formQuestion.id, "", stepId)}
                    />
                    <ButtonClose handleClick={handleCancel} />
                  </div>
                </div>
              ) : (
                <span>
                  {allFields?.find((item) => item.fsqId === formQuestion.id)?.value?.includes("|")
                    ? allFields
                        ?.find((item) => item.fsqId === formQuestion.id)
                        ?.value?.replaceAll("|", " | ")
                    : allFields?.find((item) => item.fsqId === formQuestion.id)?.value ||
                      formQuestion.question.answer.value ||
                      "--"}
                </span>
              )}
            </div>
          </div>
          <div className="steps__item-field-actions">
            {editIndex === formQuestion.id ? null : formQuestion.question?.answer?.value === "" ||
              !formQuestion.question?.answer?.value ? (
              <div
                className="steps__item-field-actions-buttons"
                onClick={() => handleEdit(formQuestion.id, stepId)}>
                <i
                  title="Adicionar Informação"
                  className="fi fi-rr-add"
                  style={{ color: "#99AA99" }}></i>
              </div>
            ) : !hasCheckBox ? (
              actions.map((action, index) =>
                renderButtons(
                  action,
                  index,
                  stepId,
                  formQuestion.question?.answer?.value,
                  formQuestion?.id,
                  formQuestion.formId,
                ),
              )
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    ))
  )
}

const AccordionHeader = ({
  id,
  hasCheckBox = false,
  title,
  indicatorValue = 0,
  handleChangeSelected,
  checked,
}) => {
  return (
    <>
      <div className="accordion__header">
        {hasCheckBox && (
          <div className="checkbox">
            <CheckBox onChange={() => handleChangeSelected(id)} checked={checked === id} />
          </div>
        )}
        <IndicatorBadge {...{ indicatorValue }} />
        <span>{title}</span>
      </div>
    </>
  )
}

const IndicatorsScreen = ({
  editedChatFields,
  values,
  handleEdit,
  handleSave,
  handleCancel,
  loadingField,
  onChangeQuestionsInfo,
  editIndex,
  formSteps,
  handleCopy,
  hasCheckBox,
  handleChangeSelected,
  selected,
  allFields,
}) => {
  return (
    <>
      {Array.isArray(formSteps) &&
        formSteps?.map(({ id, title, formQuestions, value }, stepIndex) => (
          <>
            <Accordion
              key={stepIndex}
              index={stepIndex}
              id={Math.random()}
              title={title}
              header={
                <AccordionHeader
                  id={id}
                  hasCheckBox={hasCheckBox}
                  title={title}
                  indicatorValue={value}
                  handleChangeSelected={handleChangeSelected}
                  checked={selected}
                />
              }>
              <StepFormFields
                {...{
                  formQuestions,
                  editIndex,
                  editedChatFields,
                  onChangeQuestionsInfo,
                  values,
                  loadingField,
                  handleSave,
                  handleEdit,
                  handleCopy,
                  handleCancel,
                  stepId: id,
                  hasCheckBox,
                  allFields,
                }}
              />
            </Accordion>
          </>
        ))}
    </>
  )
}

export default IndicatorsScreen
